import { Grid } from "@mui/material";
import React from "react";
import { Base } from "../../base";
import { useSelector } from "../../../store";
import AddHoursForm from "../../forms/AddHoursForm";
import SearchParams from "../../../types/searchParams";
import AddHoursFormValues from "../../../types/addHoursFormValues";
import AddHoursVM from "../../../types/addHoursVM";
import JobHoursDisplay from "./JobHourDisplay";

interface Props {
  apiGetAllUsers: () => void;
  apiCategorySearch: (search: SearchParams) => void;
  apiAddHours: (hours: AddHoursVM) => void;
  setDeleteHourModal?: React.Dispatch<
    React.SetStateAction<{
      id: number;
      note?: string | undefined;
    }>
  >;
}

const JobHoursView: React.FC<Props> = (props) => {
  const { apiAddHours } = props;
  const { job } = useSelector((store) => store.job);

  const handleSubmit = (values: AddHoursFormValues) => {
    const newJobTime: AddHoursVM = {
      jobId: job.id,
      categoryId: values?.category?.id,
      note: values.note,
      hours: values.hours?.value,
      workedOn: values.workedOn,
      workedBy: { id: values.workedBy?.id!, value: "" },
    };
    apiAddHours(newJobTime);
  };

  return (
    <Grid container direction={"column"}>
      <Grid>
        <Grid
          container
          direction={"row"}
          justifyContent={"space-between"}
          alignItems={"center"}
          pb={2}
        >
          <Grid>
            <Base.Text text="Hours" variant="h3" />
          </Grid>
        </Grid>
        <Grid pb={2}>
          <AddHoursForm {...props} handleSubmit={handleSubmit} />
        </Grid>
      </Grid>
      <Grid sx={{ maxHeight: 350, overflow: "auto" }}>
        {job.jobTimes.map((h) => (
          <JobHoursDisplay time={h} key={h.id} {...props} />
        ))}
      </Grid>
    </Grid>
  );
};

export default JobHoursView;
